module.exports = __webpack_public_path__ + "img/icon-twitter.af5ea01f.svg";